import { Meteor } from 'meteor/meteor';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import _ from 'lodash';
import moment from 'moment'; 

import { Flights } from '../flights/flights';

export const flightsStatistics = new ValidatedMethod({
	name: 'flights.statistics',
	validate: new SimpleSchema({
		from: { type: String },
		to: { type: String },
		affichage: { type: String }
	}).validator(),
	run({ from, to, affichage }) {
		
    	let startOf = affichage.slice(0, -1);
        let dataAngers = [];
        let dataNantes = [];
        let dataAll = [];

        for(let i = 0; i <= moment(to).diff(moment(from), affichage); i++) {

            let startDate = moment(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
            let endDate = moment(from).endOf(startOf).add(i, affichage).toDate();

            if(i == 0) {
            	startDate = moment(from).toDate();
            }

            if(i == moment(to).diff(moment(from), affichage)) {
            	let endDate = moment(to).toDate();
            }
            
            dataAll.push(Flights.find({date: {$gte: startDate, $lte: endDate}, status: "validated"}).fetch().length);
            dataAngers.push(Flights.find({date: {$gte: startDate, $lte: endDate}, place: "anjou", status: "validated"}).fetch().length);
            dataNantes.push(Flights.find({date: {$gte: startDate, $lte: endDate}, place: "nantes", status: "validated"}).fetch().length);
        }

		return [
			dataAll,
			dataAngers,
			dataNantes
		];
	}
});


// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	flightsStatistics,
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/statistics/flights.js
 **/